type TranslationNode = Record<string, unknown>;

const isTranslationNode = (value: unknown): value is TranslationNode =>
  typeof value === "object" && value !== null && !Array.isArray(value);

export const mergeTranslations = <T>(base: T, overrides?: unknown): T => {
  if (!isTranslationNode(base) || !isTranslationNode(overrides)) return base;

  const merged: TranslationNode = { ...base };
  Object.keys(overrides).forEach((key) => {
    const baseValue = merged[key];
    const overrideValue = overrides[key];
    merged[key] =
      isTranslationNode(baseValue) && isTranslationNode(overrideValue)
        ? mergeTranslations(baseValue, overrideValue)
        : overrideValue;
  });

  return merged as T;
};
